import { render, staticRenderFns } from "./PSIslemleri.vue?vue&type=template&id=fc05a8d8&scoped=true&"
import script from "./PSIslemleri.vue?vue&type=script&lang=js&"
export * from "./PSIslemleri.vue?vue&type=script&lang=js&"
import style0 from "./PSIslemleri.vue?vue&type=style&index=0&id=fc05a8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc05a8d8",
  null
  
)

export default component.exports